/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

export enum ErrorMessageKeysEnum {
  DEFAULT_ERROR = 'errorMessage.defaultError',
  APPOINTMENT_NOT_FOUND = 'errorMessage.publicUser.notFound',
  CUSTOMER_NOT_FOUND = 'errorMessage.publicUser.notFound',
  PUBLIC_USER_NOT_FOUND = 'errorMessage.publicUser.notFound',
  PUBLIC_USER_ALREADY_EXISTS = 'errorMessage.publicUser.alreadyExists',
}
